import type { Aplicacion, CerrarFormulario, Respuesta } from '@pasos/schemas';
import { enviar, obtener } from '../lib/api.js';

/** Llamadas del motor de formularios. Una función por endpoint, sin lógica. */

export const abrirFormulario = (formularioId: string, hito: string | null) =>
  enviar<Aplicacion>('/api/v1/formularios', { formularioId, hito });

export const leerAplicacion = (id: string) => obtener<Aplicacion>(`/api/v1/formularios/${id}`);

export const guardarRespuestas = (id: string, respuestas: Record<string, Respuesta>) =>
  enviar<Aplicacion>(`/api/v1/formularios/${id}/respuestas`, { respuestas });

export const cerrarFormulario = (id: string, cierre: CerrarFormulario) =>
  enviar<Aplicacion>(`/api/v1/formularios/${id}/cierre`, cierre);
